import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-general-form',
  templateUrl: './general-form.component.html'
})
export class GeneralFormComponent implements OnInit {
  mform:FormGroup
  constructor() { }

  ngOnInit() {
  }

  hasError(name){
    return (this.mform.get(name).invalid&&this.mform.get(name).touched)
  }
  
  invalid(name){
    return (this.mform.get(name).invalid&&this.mform.get(name).touched)
  }
  get f(){
    return this.mform.controls;
  }
}
